(function() {
    angular.module('emarket.commons').directive('htmlEditor', ['$log', function($log) {
        $.trumbowyg.svgPath = 'assets/icons.svg';
        return {
            scope: {
                htmlEditor: '=',
                htmlEditorEnabled: '='
            },
            link: function(scope, element) {
                var editor;
                var loaded = false;
                var watch = scope.$watch(function() {
                    return scope.htmlEditor;
                },
                function() {
                    if (scope.htmlEditor && !loaded) {
                        loaded = true;
                        editor.trumbowyg('html', scope.htmlEditor);
                    }
                });
                if (scope.htmlEditorEnabled !== false) {
                    editor = $(element).trumbowyg({
                        btns: [
                            [ 'formatting' ],
                            'btnGrp-semantic',
                            [ 'link' ],
                            [ 'insertImage' ],
                            'btnGrp-justify',
                            'btnGrp-lists',
                            [ 'fullscreen' ]
                        ]
                    });

                    editor.on('tbwchange', function() {
                        scope.$apply(function() {
                            scope.htmlEditor = editor.trumbowyg('html');
                        });
                    });
                    element.parents('md-input-container').addClass('md-input-has-value-force');
                }
                scope.$on('$destroy', function() {
                    if (editor) {
                        editor.trumbowyg('destroy');
                    }
                    watch();
                });
            }
        };
    }]);
}());
